export const translations = {
  en: {
    brand_tagline: "Make Every Minute Count.",
    nav_features: "Features",
    nav_categories: "Categories",
    nav_pricing: "Membership",
    nav_dashboard: "My EVERMIN",
    login: "Log In",
    signup: "Sign Up",
    logout: "Log Out",
    menu: "Menu",

    hero_badge: "Everyday help, made simple",
    headline: "What can we help you with?",
    input_placeholder: "Tell us what you need help with…",
    input_hint: "e.g. Compare two loan offers · How to renew a driving license · Plan a monthly budget",
    ask_button: "Ask EVERMIN",
    asking: "Thinking…",
    mode_understand: "Explore",
    mode_compare: "Evaluate",
    mode_decide: "Decide",
    mode_act: "Execute",
    clear: "Clear",

    result_title: "Here's what we found",
    result_ai_note: "AI-generated guidance — please verify important details.",
    result_verify: "Verify before you act",
    result_generated: "Generated just now",
    result_save: "Save to My EVERMIN",
    result_saved: "Saved",
    result_login_to_save: "Log in to save this",
    risk_low: "General guidance",
    risk_high: "High-stakes topic",

    features_title: "Four ways EVERMIN helps",
    features_subtitle: "Pick a starting point, or just type your question above.",
    feat_solve: "Solve a Problem",
    feat_solve_desc: "Break complex daily issues into simple, clear steps.",
    feat_compare: "Compare Anything",
    feat_compare_desc: "See options side-by-side for products, services and decisions.",
    feat_calc: "Smart Calculators",
    feat_calc_desc: "Work out budgets, EMIs, rent-vs-buy and time decisions.",
    feat_guides: "How-To Guides",
    feat_guides_desc: "Actionable guides for government work, home, career and tech.",
    feature_cta: "Ask EVERMIN",
    feature_dialog_note: "Type your specific situation and EVERMIN will help right away.",

    categories_title: "Explore by category",
    categories_subtitle: "Everyday life, organised into the areas that matter most.",
    category_soon: "opens with your question — try asking above",

    dashboard_title: "My EVERMIN",
    dashboard_subtitle: "Everything you save, in one calm place.",
    my_life_title: "My Life",
    my_life_subtitle: "Your money, goals, plans and recent activity — in one calm place.",
    ml_quick_actions: "Quick actions",
    ml_money: "Money",
    ml_money_empty: "No saved calculations yet.",
    ml_goals: "Goals",
    ml_goals_empty: "No savings goals yet.",
    ml_plans: "Plans",
    ml_plans_empty: "No saved plans yet.",
    ml_set_goal: "Set a savings goal",
    ml_projected: "Projected",
    ml_uploads: "Recent uploads",
    ml_no_activity: "Nothing here yet.",
    ml_library: "Saved library",
    qa_ask: "Ask EVERMIN",
    qa_scan: "Scan / Upload",
    qa_calc: "Calculate",
    qa_pdf: "Upload PDF",
    qa_compare: "Compare",
    usage_title: "Today's AI usage",
    usage_remaining: "{n} answers remaining today",
    usage_exhausted: "You've used all of today's AI answers. Resets tomorrow.",
    usage_upgrade: "Upgrade",
    usage_nudge: "{n} answers left today",
    usage_exhausted_short: "No AI answers left today",
    digest_title: "Due today",
    digest_manage: "Manage",
    digest_due_now: "Due now",
    qa_reminders: "Reminders",
    nav_reminders: "Reminders",
    rem_title: "Smart Reminders",
    rem_subtitle: "Never miss a bill, task or goal check-in.",
    rem_new: "New reminder",
    rem_quick_ph: "Try: “Kal shaam 7 baje electricity bill”",
    rem_quick_add: "Add",
    rem_quick_hint: "Type in plain English or Hindi — EVERMIN sets the date, time and repeat for you.",
    rem_parse_partial: "I couldn't catch every detail — please confirm the reminder below.",
    rem_enable_notif: "Enable browser notifications to get alerted when a reminder is due.",
    rem_notif_on: "Browser notifications enabled.",
    rem_notif_blocked: "Notifications are blocked in your browser. Reminders still show here under “Due”.",
    rem_due: "Due now",
    rem_upcoming: "Upcoming",
    rem_recurring: "Recurring",
    rem_paused: "Paused",
    rem_completed: "Completed",
    rem_empty_title: "No reminders yet",
    rem_empty_desc: "Add your first reminder above — one-time, recurring or linked to a goal.",
    rem_no_date: "No date set",
    rem_day: "Day",
    rem_days_before: "days before deadline",
    rem_last_notified: "Notified",
    rem_edit: "Edit",
    rem_pause: "Pause",
    rem_resume: "Resume",
    rem_complete: "Complete",
    rem_delete: "Delete",
    rem_created: "Reminder created.",
    rem_updated: "Reminder updated.",
    rem_deleted: "Reminder deleted.",
    rem_form_title: "New reminder",
    rem_edit_title: "Edit reminder",
    rem_form_desc: "Set what to remind you about and when.",
    rem_field_title: "Title",
    rem_field_title_ph: "e.g. Pay electricity bill",
    rem_field_desc: "Note (optional)",
    rem_type: "Type",
    rem_onetime: "One-time",
    rem_recurring_t: "Recurring",
    rem_recurrence: "Repeat",
    rem_daily: "Daily",
    rem_weekly: "Weekly",
    rem_monthly: "Monthly",
    rem_weekday: "Day of week",
    rem_dom: "Day of month",
    rem_date: "Date",
    rem_time: "Time",
    rem_link_goal: "Link to a goal (optional)",
    rem_none: "None",
    rem_offset_label: "Remind me this many days before the goal deadline",
    rem_offset_ph: "e.g. 3",
    rem_offset_hint: "Uses your goal's target date to schedule the reminder.",
    rem_tz_note: "Timezone",
    rem_save: "Save reminder",
    rem_cancel: "Cancel",
    rem_err_title: "Please add a title.",
    rem_err_time: "Please choose a time.",
    rem_err_date: "Please choose a date.",
    rem_err_goal: "Please pick a goal to link.",
    rem_err_goaldate: "That goal has no clear target date — set the goal's target date first.",
    rem_snooze_1h: "Snooze 1h",
    rem_snooze_evening: "This evening",
    rem_snoozed: "Reminder snoozed.",
    tab_problems: "Saved Problems",
    tab_comparisons: "Saved Comparisons",
    tab_guides: "Saved Guides",
    tab_calculations: "Saved Calculations",
    tab_plans: "Saved Plans",
    empty_title: "Nothing saved yet",
    empty_desc: "When you save something, it will appear here.",
    empty_cta: "Ask EVERMIN",
    delete: "Delete",
    deleted: "Removed from your saved items",
    loading: "Loading…",

    login_title: "Welcome back",
    login_subtitle: "Log in to your EVERMIN account.",
    signup_title: "Create your account",
    signup_subtitle: "Free forever. No unnecessary details.",
    name: "Name",
    email: "Email",
    password: "Password",
    continue_google: "Continue with Google",
    or: "or",
    have_account: "Already have an account?",
    no_account: "New to EVERMIN?",
    show: "Show",
    hide: "Hide",

    membership_title: "Membership",
    membership_subtitle: "Start free. Upgrade when you're ready.",
    billing_monthly: "Monthly",
    billing_annual: "Annual",
    current_plan: "Current plan",
    choose_free: "Switch to Free",
    choose_plus: "Switch to EVERMIN+",
    pricing_soon: "Pricing announced soon",
    payments_disabled: "Payments are not enabled yet — plans switch instantly for now.",
    login_to_upgrade: "Log in to manage your plan",

    footer_mission: "EVERMIN helps you understand, compare, decide and act on everyday life — clearly and calmly.",
    footer_product: "Product",
    footer_company: "Company",
    footer_legal: "Legal",
    footer_rights: "All rights reserved.",
    footer_disclaimer: "EVERMIN provides general information. For medical, legal or financial matters, consult a qualified professional.",
    status_operational: "All systems operational",

    error_generic: "Something went wrong. Please try again.",
    not_found: "Page not found",
    go_home: "Back to home",

    nav_calculators: "Calculators",
    suggested_sources: "Suggested official sources",
    sources_note: "Suggested for your own verification — not cited by the assistant.",
    generated_on: "Generated on",
    open_full_chat: "Open full chat",
    new_chat: "New chat",
    conversations: "Conversations",
    recent_conversations: "Recent conversations",
    no_conversations: "No conversations yet",
    chat_placeholder: "Ask a follow-up…",
    send: "Send",
    retry: "Retry",
    researching: "Checking the latest information…",
    researching_deep: "Checking the latest updates & clarifications…",
    jump_latest: "Jump to latest",
    new_response: "New response",
    deep_research: "Deep research",
    deep_research_hint: "Deep research: run multiple web searches for complex current topics (Plus/Pro)",
    err_limit_title: "You've used your {count} {plan} AI answers for today.",
    err_limit_desc: "Your {plan} access resets tomorrow, or upgrade now for more AI access.",
    err_upgrade_cta: "Upgrade Plan",
    err_too_large: "That file is too large. Each file must be under 10 MB.",
    err_unsupported: "Unsupported file. Please upload a JPG, PNG, WEBP image or a PDF.",
    err_temporary: "Something went wrong temporarily.",
    err_rate_title: "EVERMIN is very busy right now",
    err_rate_desc: "We're handling a lot of requests. Please wait a few seconds and try again — your question wasn't counted.",
    err_choose_another: "Try another file",
    view_conversation: "View",
    delete_conversation: "Delete conversation",

    category_guides: "Guides & topics",
    category_tools: "Related calculators",
    launch_topic: "Ask EVERMIN",
    read_guide: "Read guide",
    ai_topic: "AI topic",
    overview: "Overview",
    close: "Close",
    back: "Back",

    calculators_title: "Smart Calculators",
    calculators_subtitle: "Instant answers for everyday money decisions.",
    calc_budget: "Budget Planner",
    calc_emi: "EMI / Loan",
    calc_rentbuy: "Rent vs Buy",
    reset: "Reset",
    save_calculation: "Save calculation",
    calculation_saved: "Calculation saved",

    monthly_income: "Monthly income",
    expenses: "Expenses",
    add_expense: "Add expense",
    expense_name: "Expense",
    amount: "Amount",
    total_expenses: "Total expenses",
    savings: "Monthly savings",
    savings_rate: "Savings rate",

    loan_amount: "Loan amount",
    interest_rate: "Interest rate (% per year)",
    tenure_years: "Tenure (years)",
    monthly_emi: "Monthly EMI",
    total_interest: "Total interest",
    total_payment: "Total payment",

    monthly_rent: "Monthly rent",
    rent_increase: "Annual rent increase (%)",
    home_price: "Home price",
    down_payment: "Down payment",
    loan_rate: "Loan interest rate (%)",
    loan_tenure: "Loan tenure (years)",
    maintenance: "Monthly maintenance",
    horizon_years: "Time horizon (years)",
    total_rent_cost: "Total rent cost",
    total_buy_cost: "Total buy cost",
    rentbuy_rent_better: "Renting is cheaper over this period",
    rentbuy_buy_better: "Buying is cheaper over this period",
    rentbuy_equal: "Renting and buying cost about the same",
    rentbuy_note: "Simple cash-flow comparison only. It does not include property value growth, tax or resale — treat it as a starting point.",

    nav_guides: "Guides",
    guides_title: "Guide Library",
    guides_subtitle: "Simple, practical how-to guides and topics for everyday life.",
    search_guides: "Search guides…",
    all_categories: "All",
    no_guides: "No guides match your search.",

    web_sources_title: "Sources from the web",
    web_sources_note: "Live results found for this answer. Please open and verify.",
    source_date: "Published",
    web_verified_badge: "Web-verified",

    compare_title: "Compare Anything",
    compare_subtitle: "Put two options side by side and see them clearly.",
    option_a: "Option A",
    option_b: "Option B",
    compare_context: "What are you comparing? (optional)",
    compare_context_ph: "e.g. for a family of four, on a tight budget",
    option_a_ph: "e.g. Rent a home",
    option_b_ph: "e.g. Buy a home",
    compare_btn: "Compare",
    comparing: "Comparing…",
    compare_summary: "Summary",
    pros: "Pros",
    cons: "Cons",
    recommendation: "Recommendation",
    save_comparison: "Save comparison",
    comparison_saved: "Comparison saved",
    compare_empty: "Enter two options above to see a side-by-side comparison.",

    forgot_password: "Forgot password?",
    forgot_title: "Reset your password",
    forgot_subtitle: "Enter your email and we'll send you a secure reset link.",
    send_reset: "Send reset link",
    reset_email_sent: "Check your email.",
    reset_email_note: "If an account exists for that address, we've sent a link to reset your password. It expires in 30 minutes.",
    reset_title: "Choose a new password",
    reset_subtitle: "Enter a new password for your account.",
    new_password: "New password",
    reset_btn: "Reset password",
    reset_done: "Password reset. Please log in.",
    invalid_reset: "This reset link is invalid or has expired.",
    back_to_login: "Back to log in",

    nav_assistant: "Photo & Docs",
    assistant_title: "Photo & Document Help",
    assistant_subtitle: "Upload a photo or PDF and EVERMIN will explain it in simple words.",
    assistant_hint: "Supports JPG, PNG, WEBP and PDF up to 10 MB.",
    choose_file: "Choose a photo or PDF",
    ask_about_file: "What would you like to know? (optional)",
    ask_about_file_ph: "e.g. What is this document and what should I do?",
    analyze_btn: "Explain this",
    analyzing: "Reading your file…",
    assistant_empty: "Upload a file to get a simple explanation and next steps.",
    assistant_login: "Log in to use Photo & Document Help.",
    remove_file: "Remove",
    assistant_disclaimer: "EVERMIN describes what it can see and never guesses. For sensitive documents, verify with the issuing authority or a professional.",

    settings_title: "Settings",
    settings_subtitle: "Manage your account, language and plan.",
    account_section: "Account",
    profile_name: "Your name",
    save_changes: "Save changes",
    saved_changes: "Changes saved",
    language_label: "Language",
    membership_section: "Membership",
    saved_data_section: "Your saved data",
    saved_data_desc: "View and manage everything you've saved in My EVERMIN.",
    open_dashboard: "Open My EVERMIN",
    memory_section: "Personal Context",
    memory_desc: "Things EVERMIN remembers to personalise your answers. It never stores passwords, OTPs, or card/ID numbers.",
    memory_empty: "No memories yet. Tell EVERMIN a preference in chat (e.g. \"I'm vegetarian\"), or add one below.",
    memory_add_placeholder: "Add something to remember (e.g. I prefer trains over flights)",
    memory_add_btn: "Add memory",
    memory_edit: "Edit",
    memory_save: "Save",
    memory_cancel: "Cancel",
    memory_clear_all: "Clear all",
    memory_clear_confirm: "Delete all your saved memories? This can't be undone.",
    memory_deleted: "Memory removed",
    memory_saved: "Memory saved",
    memory_cleared: "All memories cleared",
    goals_title: "Goals & Plans",
    goals_subtitle: "Turn an objective into a practical, trackable plan.",
    goal_new: "New goal",
    goal_title_label: "What do you want to achieve?",
    goal_title_ph: "e.g. Save ₹1,00,000 this year",
    goal_desc_label: "Details (optional)",
    goal_desc_ph: "Any context that helps EVERMIN plan (budget, constraints, why)",
    goal_category: "Category",
    goal_target_date: "Target date",
    goal_priority: "Priority",
    goal_create: "Create goal",
    goal_generate_plan: "Generate AI plan",
    goal_regenerate_plan: "Regenerate plan",
    goal_objective: "Objective",
    goal_milestones: "Milestones",
    goal_no_plan: "No plan yet. Generate an AI plan or add your own milestones.",
    goal_progress: "Progress",
    goal_smart_ph: "Update in your words (e.g. I completed step 2, or I have only 2 weeks left)",
    goal_smart_apply: "Apply update",
    goal_pause: "Pause",
    goal_resume: "Resume",
    goal_complete: "Mark complete",
    goal_archive: "Archive",
    goal_delete: "Delete goal",
    goal_delete_confirm: "Delete this goal and its plan? This can't be undone.",
    goal_empty: "No goals yet. Create your first goal to get a smart plan.",
    goal_saved: "Goal saved",
    goal_deleted: "Goal deleted",
    goal_plan_ready: "Your plan is ready",
    goals_dash_title: "Goals & Plans",
    goals_dash_view: "View all",
    cat_saving: "Saving",
    cat_learning: "Learning",
    cat_business: "Business",
    cat_travel: "Travel",
    cat_fitness: "Fitness",
    cat_project: "Project",
    cat_custom: "Custom",
    status_active: "Active",
    status_paused: "Paused",
    status_completed: "Completed",
    status_archived: "Archived",
    logout_section: "Sign out",
    settings_link: "Settings",

    per_month: "/month",
    upgrade_now: "Upgrade to Premium",
    upgrade_premium: "Upgrade — ₹199/month",
    current_plan_free: "You're on the Free plan",
    current_plan_premium: "You're on EVERMIN Premium",
    manage_plan: "Manage plan",
    cancel_plan: "Cancel Premium",
    cancel_confirm: "Cancel Premium? You'll keep access until your renewal date.",
    plan_cancelled: "Premium will end on your renewal date",
    cancelling_note: "Cancelling — active until",
    renews_on: "Renews on",
    most_popular: "Most popular",
    free_vs_premium: "Compare Free & Premium",
    upgrade_success: "Welcome to EVERMIN {plan}!",
    welcome_title: "🎉 Welcome to EVERMIN!",
    welcome_thanks: "Thank you for choosing EVERMIN. Your membership is now active.",
    welcome_ready: "Your {plan} plan is ready to use.",
    welcome_ai_limit: "AI limit: {count} successful answers per day.",
    welcome_cta: "Start exploring",
    sandbox_note: "Payments are processed securely by Razorpay. See our Refund & Cancellation Policy for cancellation and refunds.",
    downgrade_free: "Switch to Free",
    keep_premium: "Keep Premium",
    processing: "Processing…",

    ai_per_day_label: "AI answers/day",
    see_plans: "See plans",
    you_are_on: "You're on",
    upgrade_to: "Upgrade to",
    choose_plan: "Choose plan",
    switch_plan: "Switch to this plan",
    start_free: "Start Free",
    upgrade_cta: "Upgrade",
    ob_question: "What do you want EVERMIN to help you with?",
    ob_money: "Money & Savings",
    ob_problems: "Everyday Problems",
    ob_docs: "Documents & PDFs",
    ob_compare: "Compare Things",
    ob_travel: "Travel & Planning",
    ob_everything: "Everything",
    ob_skip: "Skip for now",
    ob_perfect: "Perfect. Let's set up your EVERMIN.",
    ob_setup_desc: "Create a free account to save your progress and unlock your personal EVERMIN experience.",
    ob_signup: "Sign Up Free",
    ob_login: "Log In",
    ml_teaser_headline: "Your Life. One Smart Place.",
    ml_teaser_sub: "Save your calculations, goals, plans, comparisons and important EVERMIN work in one personal place.",
    ml_teaser_preview_label: "A peek at your personal EVERMIN",
    ml_teaser_make_yours: "Create your free account to make this yours.",
    ml_teaser_cta: "Create My EVERMIN — Free",
    ml_teaser_no_payment: "No payment required.",
    ml_teaser_personalize: "First, tell us what you need",
    ob_build: "Perfect. Let's build your EVERMIN.",
    intro_offer: "3-Month Introductory Offer",
    launch_convert_msg: "Try EVERMIN free. Experience what it can do. Upgrade when you need more.",
    launch_badge: "LIMITED TIME FREE",
    launch_banner: "EVERMIN Launch Period: selected premium features are free for everyone right now. Try them today, upgrade to keep access when the launch ends.",
    launch_free_support: "Try this premium feature free during the EVERMIN Launch Period.",
    upgrade_to_keep: "Upgrade to keep access",
    keep_plan: "Keep my plan",
    free_tier: "Free",
    upgrade_prompt_paid: "Get more from EVERMIN",
    limit_title: "You've reached your daily AI limit",
    limit_desc: "You've used your {count} {plan} AI answers for today. Your access resets tomorrow, or upgrade now for more AI access.",
    limit_reached_title: "Daily AI limit reached",
    limit_pro_desc: "You've used all 200 Pro AI answers for today. Your limit resets tomorrow.",

    take_photo: "Take a photo",
    upload_image: "Upload photo or PDF",
    ask_about_image_ph: "Ask about this photo… (optional)",
    image_type_error: "Please choose a JPG, PNG, WEBP image or a PDF.",
    image_size_error: "That file is over 10 MB. Please choose a smaller one.",

    tab_conversations: "Conversations",
    upgrade_prompt: "You're on the Free plan",
    upgrade_prompt_desc: "Upgrade for higher daily AI limits, more saves and advanced tools.",
    see_premium: "See plans",
    saved_limit_reached: "You've reached your Free saving limit. Upgrade for unlimited.",
    continue_chat: "Continue",

    your_budget: "Your budget (optional)",
    your_budget_ph: "e.g. under ₹20,000",
    your_needs: "Your needs & priorities (optional)",
    your_needs_ph: "e.g. long battery, good camera, for daily office use",
    best_for_you: "Best for you",
    running_cost_label: "Running / maintenance cost",
    best_for_label: "Best for",
    advanced_compare: "Personalise (Mere liye kaunsa?)",

    trust_title: "Trust & Sources",
    trust_subtitle: "How EVERMIN works, and how to use it wisely.",
    privacy_title: "Privacy Policy",
    terms_title: "Terms of Use",
    contact_title: "Contact",
    contact_subtitle: "We'd love to hear from you.",
    footer_about: "About",
    footer_contact: "Contact",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_refund: "Refund & Cancellation",
    footer_trust: "Trust & Sources",
    refund_title: "Refund & Cancellation Policy",
    refund_subtitle: "How EVERMIN memberships can be cancelled and when refunds apply.",
  },
  hi: {
    brand_tagline: "हर मिनट को कीमती बनाएं।",
    nav_features: "फ़ीचर्स",
    nav_categories: "श्रेणियाँ",
    nav_pricing: "सदस्यता",
    nav_dashboard: "मेरा EVERMIN",
    login: "लॉग इन",
    signup: "साइन अप",
    logout: "लॉग आउट",
    menu: "मेन्यू",

    hero_badge: "रोज़मर्रा की मदद, आसान तरीके से",
    headline: "हम आपकी क्या सहायता कर सकते हैं?",
    input_placeholder: "बताएं कि आपको किस चीज़ में मदद चाहिए…",
    input_hint: "जैसे दो लोन ऑफ़र की तुलना · ड्राइविंग लाइसेंस रिन्यू कैसे करें · मासिक बजट बनाएं",
    ask_button: "EVERMIN से पूछें",
    asking: "सोच रहे हैं…",
    mode_understand: "एक्सप्लोर करें",
    mode_compare: "आकलन करें",
    mode_decide: "तय करें",
    mode_act: "अमल करें",
    clear: "साफ़ करें",

    result_title: "यह मिला हमें",
    result_ai_note: "AI द्वारा तैयार मार्गदर्शन — महत्वपूर्ण जानकारी ज़रूर जाँचें।",
    result_verify: "कार्य करने से पहले जाँच करें",
    result_generated: "अभी तैयार किया गया",
    result_save: "मेरा EVERMIN में सहेजें",
    result_saved: "सहेजा गया",
    result_login_to_save: "सहेजने के लिए लॉग इन करें",
    risk_low: "सामान्य मार्गदर्शन",
    risk_high: "संवेदनशील विषय",

    features_title: "EVERMIN मदद करने के चार तरीके",
    features_subtitle: "एक शुरुआत चुनें, या ऊपर अपना सवाल लिखें।",
    feat_solve: "समस्या सुलझाएं",
    feat_solve_desc: "रोज़मर्रा की उलझनों को आसान, स्पष्ट कदमों में बाँटें।",
    feat_compare: "कुछ भी तुलना करें",
    feat_compare_desc: "उत्पाद, सेवाएँ और निर्णय साथ-साथ देखें।",
    feat_calc: "स्मार्ट कैलकुलेटर",
    feat_calc_desc: "बजट, EMI, किराया बनाम खरीद और समय के निर्णय निकालें।",
    feat_guides: "हाउ-टू गाइड",
    feat_guides_desc: "सरकारी काम, घर, करियर और टेक के लिए व्यावहारिक गाइड।",
    feature_cta: "EVERMIN से पूछें",
    feature_dialog_note: "अपनी स्थिति लिखें और EVERMIN तुरंत मदद करेगा।",

    categories_title: "श्रेणी अनुसार देखें",
    categories_subtitle: "रोज़मर्रा की ज़िंदगी, ज़रूरी क्षेत्रों में व्यवस्थित।",
    category_soon: "आपके सवाल के साथ खुलती है — ऊपर पूछ कर देखें",

    dashboard_title: "मेरा EVERMIN",
    dashboard_subtitle: "आपकी सहेजी हर चीज़, एक शांत जगह पर।",
    my_life_title: "माय लाइफ",
    my_life_subtitle: "आपका पैसा, लक्ष्य, प्लान और हाल की गतिविधि — एक शांत जगह पर।",
    ml_quick_actions: "त्वरित क्रियाएं",
    ml_money: "पैसा",
    ml_money_empty: "अभी तक कोई सहेजी गणना नहीं।",
    ml_goals: "लक्ष्य",
    ml_goals_empty: "अभी तक कोई बचत लक्ष्य नहीं।",
    ml_plans: "प्लान",
    ml_plans_empty: "अभी तक कोई सहेजा प्लान नहीं।",
    ml_set_goal: "बचत लक्ष्य सेट करें",
    ml_projected: "अनुमानित",
    ml_uploads: "हाल के अपलोड",
    ml_no_activity: "अभी यहाँ कुछ नहीं है।",
    ml_library: "सहेजी लाइब्रेरी",
    qa_ask: "EVERMIN से पूछें",
    qa_scan: "स्कैन / अपलोड",
    qa_calc: "गणना करें",
    qa_pdf: "PDF अपलोड करें",
    qa_compare: "तुलना करें",
    usage_title: "आज का AI उपयोग",
    usage_remaining: "आज {n} उत्तर बाकी",
    usage_exhausted: "आपने आज के सभी AI उत्तर उपयोग कर लिए हैं। कल रीसेट होगा।",
    usage_upgrade: "अपग्रेड",
    usage_nudge: "आज {n} उत्तर बाकी",
    usage_exhausted_short: "आज कोई AI उत्तर बाकी नहीं",
    digest_title: "आज देय",
    digest_manage: "प्रबंधित करें",
    digest_due_now: "अभी देय",
    qa_reminders: "रिमाइंडर",
    nav_reminders: "रिमाइंडर",
    rem_title: "स्मार्ट रिमाइंडर",
    rem_subtitle: "कोई बिल, काम या लक्ष्य चेक-इन कभी न छूटे।",
    rem_new: "नया रिमाइंडर",
    rem_quick_ph: "जैसे: “कल शाम 7 बजे बिजली बिल”",
    rem_quick_add: "जोड़ें",
    rem_quick_hint: "हिंदी या अंग्रेज़ी में लिखें — EVERMIN तारीख, समय और दोहराव खुद सेट कर देगा।",
    rem_parse_partial: "मैं हर जानकारी नहीं समझ पाया — कृपया नीचे रिमाइंडर की पुष्टि करें।",
    rem_enable_notif: "रिमाइंडर आने पर सूचना पाने के लिए ब्राउज़र नोटिफिकेशन चालू करें।",
    rem_notif_on: "ब्राउज़र नोटिफिकेशन चालू हो गए।",
    rem_notif_blocked: "आपके ब्राउज़र में नोटिफिकेशन बंद हैं। रिमाइंडर यहाँ “अभी देय” में दिखते रहेंगे।",
    rem_due: "अभी देय",
    rem_upcoming: "आगामी",
    rem_recurring: "दोहराव वाले",
    rem_paused: "रुके हुए",
    rem_completed: "पूरे हुए",
    rem_empty_title: "अभी कोई रिमाइंडर नहीं",
    rem_empty_desc: "ऊपर अपना पहला रिमाइंडर जोड़ें — एक बार, दोहराव वाला या किसी लक्ष्य से जुड़ा।",
    rem_no_date: "कोई तारीख नहीं",
    rem_day: "दिन",
    rem_days_before: "दिन पहले",
    rem_last_notified: "सूचित किया गया",
    rem_edit: "बदलें",
    rem_pause: "रोकें",
    rem_resume: "फिर शुरू",
    rem_complete: "पूरा करें",
    rem_delete: "हटाएं",
    rem_created: "रिमाइंडर बन गया।",
    rem_updated: "रिमाइंडर अपडेट हुआ।",
    rem_deleted: "रिमाइंडर हटा दिया।",
    rem_form_title: "नया रिमाइंडर",
    rem_edit_title: "रिमाइंडर बदलें",
    rem_form_desc: "तय करें किस बारे में और कब याद दिलाना है।",
    rem_field_title: "शीर्षक",
    rem_field_title_ph: "जैसे: बिजली बिल भरना",
    rem_field_desc: "नोट (वैकल्पिक)",
    rem_type: "प्रकार",
    rem_onetime: "एक बार",
    rem_recurring_t: "दोहराव",
    rem_recurrence: "दोहराएं",
    rem_daily: "रोज़",
    rem_weekly: "साप्ताहिक",
    rem_monthly: "मासिक",
    rem_weekday: "सप्ताह का दिन",
    rem_dom: "महीने की तारीख",
    rem_date: "तारीख",
    rem_time: "समय",
    rem_link_goal: "किसी लक्ष्य से जोड़ें (वैकल्पिक)",
    rem_none: "कोई नहीं",
    rem_offset_label: "लक्ष्य की समय-सीमा से इतने दिन पहले याद दिलाएं",
    rem_offset_ph: "जैसे: 3",
    rem_offset_hint: "यह आपके लक्ष्य की लक्षित तारीख से रिमाइंडर तय करता है।",
    rem_tz_note: "टाइमज़ोन",
    rem_save: "रिमाइंडर सहेजें",
    rem_cancel: "रद्द करें",
    rem_err_title: "कृपया शीर्षक जोड़ें।",
    rem_err_time: "कृपया समय चुनें।",
    rem_err_date: "कृपया तारीख चुनें।",
    rem_err_goal: "कृपया जोड़ने के लिए एक लक्ष्य चुनें।",
    rem_err_goaldate: "उस लक्ष्य की स्पष्ट लक्षित तारीख नहीं है — पहले लक्ष्य की तारीख सेट करें।",
    rem_snooze_1h: "1 घंटे बाद",
    rem_snooze_evening: "आज शाम",
    rem_snoozed: "रिमाइंडर स्थगित किया गया।",
    tab_problems: "सहेजी गई समस्याएं",
    tab_comparisons: "सहेजी गई तुलनाएं",
    tab_guides: "सहेजी गई गाइड",
    tab_calculations: "सहेजे गए कैलकुलेशन",
    tab_plans: "सहेजी गई योजनाएं",
    empty_title: "अभी कुछ सहेजा नहीं गया",
    empty_desc: "जब आप कुछ सहेजेंगे, वह यहाँ दिखेगा।",
    empty_cta: "EVERMIN से पूछें",
    delete: "हटाएं",
    deleted: "सहेजे गए आइटम से हटाया गया",
    loading: "लोड हो रहा है…",

    login_title: "वापसी पर स्वागत है",
    login_subtitle: "अपने EVERMIN खाते में लॉग इन करें।",
    signup_title: "अपना खाता बनाएं",
    signup_subtitle: "हमेशा मुफ़्त। कोई ग़ैर-ज़रूरी जानकारी नहीं।",
    name: "नाम",
    email: "ईमेल",
    password: "पासवर्ड",
    continue_google: "Google से जारी रखें",
    or: "या",
    have_account: "पहले से खाता है?",
    no_account: "EVERMIN पर नए हैं?",
    show: "दिखाएं",
    hide: "छिपाएं",

    membership_title: "सदस्यता",
    membership_subtitle: "मुफ़्त शुरू करें। तैयार होने पर अपग्रेड करें।",
    billing_monthly: "मासिक",
    billing_annual: "वार्षिक",
    current_plan: "वर्तमान प्लान",
    choose_free: "फ्री पर जाएं",
    choose_plus: "EVERMIN+ पर जाएं",
    pricing_soon: "मूल्य जल्द घोषित होगा",
    payments_disabled: "भुगतान अभी सक्षम नहीं है — फ़िलहाल प्लान तुरंत बदलते हैं।",
    login_to_upgrade: "अपना प्लान प्रबंधित करने के लिए लॉग इन करें",

    footer_mission: "EVERMIN आपको रोज़मर्रा की ज़िंदगी को समझने, तुलना करने, निर्णय लेने और कदम उठाने में स्पष्ट रूप से मदद करता है।",
    footer_product: "उत्पाद",
    footer_company: "कंपनी",
    footer_legal: "कानूनी",
    footer_rights: "सर्वाधिकार सुरक्षित।",
    footer_disclaimer: "EVERMIN सामान्य जानकारी प्रदान करता है। चिकित्सा, कानूनी या वित्तीय मामलों के लिए योग्य पेशेवर से सलाह लें।",
    status_operational: "सभी सिस्टम चालू हैं",

    error_generic: "कुछ गड़बड़ हुई। कृपया पुनः प्रयास करें।",
    not_found: "पेज नहीं मिला",
    go_home: "होम पर वापस जाएं",

    nav_calculators: "कैलकुलेटर",
    suggested_sources: "सुझाए गए आधिकारिक स्रोत",
    sources_note: "आपकी अपनी पुष्टि के लिए सुझाए गए — असिस्टेंट द्वारा उद्धृत नहीं।",
    generated_on: "तैयार किया गया",
    open_full_chat: "पूरा चैट खोलें",
    new_chat: "नई चैट",
    conversations: "बातचीत",
    recent_conversations: "हाल की बातचीत",
    no_conversations: "अभी कोई बातचीत नहीं",
    chat_placeholder: "आगे पूछें…",
    send: "भेजें",
    retry: "पुनः प्रयास करें",
    researching: "ताज़ा जानकारी जाँच रहे हैं…",
    researching_deep: "ताज़ा अपडेट और स्पष्टीकरण जाँच रहे हैं…",
    jump_latest: "नवीनतम पर जाएं",
    new_response: "नया उत्तर",
    deep_research: "गहन शोध",
    deep_research_hint: "गहन शोध: जटिल वर्तमान विषयों के लिए कई वेब खोजें (Plus/Pro)",
    err_limit_title: "आपने आज अपने {count} {plan} AI उत्तर उपयोग कर लिए हैं।",
    err_limit_desc: "आपकी {plan} पहुंच कल रीसेट होगी, या अधिक AI पहुंच के लिए अभी अपग्रेड करें।",
    err_upgrade_cta: "प्लान अपग्रेड करें",
    err_too_large: "यह फ़ाइल बहुत बड़ी है। हर फ़ाइल 10 MB से कम होनी चाहिए।",
    err_unsupported: "असमर्थित फ़ाइल। कृपया JPG, PNG, WEBP इमेज या PDF अपलोड करें।",
    err_temporary: "कुछ अस्थायी रूप से गड़बड़ हो गई।",
    err_rate_title: "EVERMIN अभी बहुत व्यस्त है",
    err_rate_desc: "अभी बहुत सारे अनुरोध आ रहे हैं। कृपया कुछ सेकंड रुककर फिर कोशिश करें — आपका सवाल गिना नहीं गया।",
    err_choose_another: "दूसरी फ़ाइल आज़माएं",
    view_conversation: "देखें",
    delete_conversation: "बातचीत हटाएं",

    category_guides: "गाइड और विषय",
    category_tools: "संबंधित कैलकुलेटर",
    launch_topic: "EVERMIN से पूछें",
    read_guide: "गाइड पढ़ें",
    ai_topic: "AI विषय",
    overview: "अवलोकन",
    close: "बंद करें",
    back: "वापस",

    calculators_title: "स्मार्ट कैलकुलेटर",
    calculators_subtitle: "रोज़मर्रा के पैसों के निर्णयों के तुरंत जवाब।",
    calc_budget: "बजट प्लानर",
    calc_emi: "EMI / लोन",
    calc_rentbuy: "किराया बनाम खरीद",
    reset: "रीसेट",
    save_calculation: "कैलकुलेशन सहेजें",
    calculation_saved: "कैलकुलेशन सहेजा गया",

    monthly_income: "मासिक आय",
    expenses: "खर्च",
    add_expense: "खर्च जोड़ें",
    expense_name: "खर्च",
    amount: "राशि",
    total_expenses: "कुल खर्च",
    savings: "मासिक बचत",
    savings_rate: "बचत दर",

    loan_amount: "लोन राशि",
    interest_rate: "ब्याज दर (% प्रति वर्ष)",
    tenure_years: "अवधि (वर्ष)",
    monthly_emi: "मासिक EMI",
    total_interest: "कुल ब्याज",
    total_payment: "कुल भुगतान",

    monthly_rent: "मासिक किराया",
    rent_increase: "वार्षिक किराया वृद्धि (%)",
    home_price: "घर की कीमत",
    down_payment: "डाउन पेमेंट",
    loan_rate: "लोन ब्याज दर (%)",
    loan_tenure: "लोन अवधि (वर्ष)",
    maintenance: "मासिक रखरखाव",
    horizon_years: "समय अवधि (वर्ष)",
    total_rent_cost: "कुल किराया लागत",
    total_buy_cost: "कुल खरीद लागत",
    rentbuy_rent_better: "इस अवधि में किराया सस्ता है",
    rentbuy_buy_better: "इस अवधि में खरीदना सस्ता है",
    rentbuy_equal: "किराया और खरीद लगभग बराबर हैं",
    rentbuy_note: "यह केवल सरल नकदी-प्रवाह तुलना है। इसमें संपत्ति मूल्य वृद्धि, कर या पुनर्विक्रय शामिल नहीं — इसे शुरुआती बिंदु मानें।",

    nav_guides: "गाइड",
    guides_title: "गाइड लाइब्रेरी",
    guides_subtitle: "रोज़मर्रा की ज़िंदगी के लिए सरल, व्यावहारिक हाउ-टू गाइड और विषय।",
    search_guides: "गाइड खोजें…",
    all_categories: "सभी",
    no_guides: "आपकी खोज से कोई गाइड मेल नहीं खाती।",

    web_sources_title: "वेब से स्रोत",
    web_sources_note: "इस उत्तर के लिए मिले लाइव परिणाम। कृपया खोलकर जाँचें।",
    source_date: "प्रकाशित",
    web_verified_badge: "वेब-सत्यापित",

    compare_title: "कुछ भी तुलना करें",
    compare_subtitle: "दो विकल्पों को साथ-साथ रखें और स्पष्ट देखें।",
    option_a: "विकल्प A",
    option_b: "विकल्प B",
    compare_context: "आप किसकी तुलना कर रहे हैं? (वैकल्पिक)",
    compare_context_ph: "जैसे चार लोगों के परिवार के लिए, कम बजट में",
    option_a_ph: "जैसे घर किराए पर लें",
    option_b_ph: "जैसे घर खरीदें",
    compare_btn: "तुलना करें",
    comparing: "तुलना हो रही है…",
    compare_summary: "सारांश",
    pros: "फायदे",
    cons: "नुकसान",
    recommendation: "सिफ़ारिश",
    save_comparison: "तुलना सहेजें",
    comparison_saved: "तुलना सहेजी गई",
    compare_empty: "साइड-बाय-साइड तुलना देखने के लिए ऊपर दो विकल्प दर्ज करें।",

    forgot_password: "पासवर्ड भूल गए?",
    forgot_title: "अपना पासवर्ड रीसेट करें",
    forgot_subtitle: "अपना ईमेल दर्ज करें और हम आपको एक सुरक्षित रीसेट लिंक भेजेंगे।",
    forgot_name_note: "आपकी सुरक्षा के लिए, अपने खाते का नाम दर्ज करें।",
    send_reset: "रीसेट लिंक भेजें",
    reset_email_sent: "अपना ईमेल देखें।",
    reset_email_note: "यदि उस पते का खाता मौजूद है, तो हमने पासवर्ड रीसेट करने का लिंक भेज दिया है। यह 30 मिनट में समाप्त होगा।",
    reset_created: "रीसेट लिंक बन गया",
    reset_token_note: "आपकी सुरक्षा के लिए यह लिंक एक बार काम करता है और 30 मिनट में समाप्त हो जाता है।",
    copy_link: "रीसेट लिंक कॉपी करें",
    copied: "कॉपी किया गया",
    continue_reset: "रीसेट पर जाएं",
    reset_generic: "यदि इस ईमेल का खाता मौजूद है, तो एक रीसेट लिंक बना दिया गया है।",
    reset_title: "नया पासवर्ड चुनें",
    reset_subtitle: "अपने खाते के लिए नया पासवर्ड दर्ज करें।",
    new_password: "नया पासवर्ड",
    reset_btn: "पासवर्ड रीसेट करें",
    reset_done: "पासवर्ड रीसेट हो गया। कृपया लॉग इन करें।",
    invalid_reset: "यह रीसेट लिंक अमान्य है या समाप्त हो गया है।",
    back_to_login: "लॉग इन पर वापस जाएं",

    nav_assistant: "फ़ोटो और दस्तावेज़",
    assistant_title: "फ़ोटो और दस्तावेज़ मदद",
    assistant_subtitle: "एक फ़ोटो या PDF अपलोड करें और EVERMIN इसे आसान शब्दों में समझाएगा।",
    assistant_hint: "JPG, PNG, WEBP और PDF, 10 MB तक समर्थित।",
    choose_file: "फ़ोटो या PDF चुनें",
    ask_about_file: "आप क्या जानना चाहते हैं? (वैकल्पिक)",
    ask_about_file_ph: "जैसे यह दस्तावेज़ क्या है और मुझे क्या करना चाहिए?",
    analyze_btn: "इसे समझाएं",
    analyzing: "आपकी फ़ाइल पढ़ रहे हैं…",
    assistant_empty: "आसान व्याख्या और अगले कदम पाने के लिए एक फ़ाइल अपलोड करें।",
    assistant_login: "फ़ोटो और दस्तावेज़ मदद के लिए लॉग इन करें।",
    remove_file: "हटाएं",
    assistant_disclaimer: "EVERMIN वही बताता है जो वह देख सकता है और कभी अनुमान नहीं लगाता। संवेदनशील दस्तावेज़ों के लिए जारीकर्ता प्राधिकरण या पेशेवर से पुष्टि करें।",

    settings_title: "सेटिंग्स",
    settings_subtitle: "अपना खाता, भाषा और प्लान प्रबंधित करें।",
    account_section: "खाता",
    profile_name: "आपका नाम",
    save_changes: "बदलाव सहेजें",
    saved_changes: "बदलाव सहेजे गए",
    language_label: "भाषा",
    membership_section: "सदस्यता",
    saved_data_section: "आपका सहेजा डेटा",
    saved_data_desc: "मेरा EVERMIN में सहेजी सभी चीज़ें देखें और प्रबंधित करें।",
    open_dashboard: "मेरा EVERMIN खोलें",
    memory_section: "व्यक्तिगत संदर्भ",
    memory_desc: "आपके उत्तरों को वैयक्तिकृत करने के लिए EVERMIN जो बातें याद रखता है। यह कभी भी पासवर्ड, OTP या कार्ड/ID नंबर नहीं रखता।",
    memory_empty: "अभी कोई मेमोरी नहीं। चैट में अपनी पसंद बताएं (जैसे \"मैं शाकाहारी हूँ\"), या नीचे जोड़ें।",
    memory_add_placeholder: "याद रखने के लिए कुछ जोड़ें (जैसे मुझे फ्लाइट से ज़्यादा ट्रेन पसंद है)",
    memory_add_btn: "मेमोरी जोड़ें",
    memory_edit: "बदलें",
    memory_save: "सहेजें",
    memory_cancel: "रद्द करें",
    memory_clear_all: "सब हटाएं",
    memory_clear_confirm: "अपनी सभी सहेजी मेमोरी हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
    memory_deleted: "मेमोरी हटाई गई",
    memory_saved: "मेमोरी सहेजी गई",
    memory_cleared: "सभी मेमोरी हटा दी गईं",
    goals_title: "लक्ष्य और योजनाएं",
    goals_subtitle: "किसी उद्देश्य को एक व्यावहारिक, ट्रैक करने योग्य योजना में बदलें।",
    goal_new: "नया लक्ष्य",
    goal_title_label: "आप क्या हासिल करना चाहते हैं?",
    goal_title_ph: "जैसे इस साल ₹1,00,000 बचाना",
    goal_desc_label: "विवरण (वैकल्पिक)",
    goal_desc_ph: "कोई भी संदर्भ जो EVERMIN को योजना बनाने में मदद करे",
    goal_category: "श्रेणी",
    goal_target_date: "लक्ष्य तिथि",
    goal_priority: "प्राथमिकता",
    goal_create: "लक्ष्य बनाएं",
    goal_generate_plan: "AI योजना बनाएं",
    goal_regenerate_plan: "योजना फिर से बनाएं",
    goal_objective: "उद्देश्य",
    goal_milestones: "मील के पत्थर",
    goal_no_plan: "अभी कोई योजना नहीं। AI योजना बनाएं या अपने मील के पत्थर जोड़ें।",
    goal_progress: "प्रगति",
    goal_smart_ph: "अपने शब्दों में अपडेट करें (जैसे मैंने स्टेप 2 पूरा किया, या केवल 2 हफ्ते बचे हैं)",
    goal_smart_apply: "अपडेट लागू करें",
    goal_pause: "रोकें",
    goal_resume: "जारी रखें",
    goal_complete: "पूर्ण चिह्नित करें",
    goal_archive: "संग्रह करें",
    goal_delete: "लक्ष्य हटाएं",
    goal_delete_confirm: "इस लक्ष्य और इसकी योजना को हटाएं? इसे पूर्ववत नहीं किया जा सकता।",
    goal_empty: "अभी कोई लक्ष्य नहीं। स्मार्ट योजना पाने के लिए अपना पहला लक्ष्य बनाएं।",
    goal_saved: "लक्ष्य सहेजा गया",
    goal_deleted: "लक्ष्य हटाया गया",
    goal_plan_ready: "आपकी योजना तैयार है",
    goals_dash_title: "लक्ष्य और योजनाएं",
    goals_dash_view: "सभी देखें",
    cat_saving: "बचत",
    cat_learning: "सीखना",
    cat_business: "व्यापार",
    cat_travel: "यात्रा",
    cat_fitness: "फिटनेस",
    cat_project: "प्रोजेक्ट",
    cat_custom: "कस्टम",
    status_active: "सक्रिय",
    status_paused: "रुका हुआ",
    status_completed: "पूर्ण",
    status_archived: "संग्रहीत",
    logout_section: "साइन आउट",
    settings_link: "सेटिंग्स",

    per_month: "/माह",
    upgrade_now: "प्रीमियम में अपग्रेड करें",
    upgrade_premium: "अपग्रेड — ₹199/माह",
    current_plan_free: "आप फ्री प्लान पर हैं",
    current_plan_premium: "आप EVERMIN प्रीमियम पर हैं",
    manage_plan: "प्लान प्रबंधित करें",
    cancel_plan: "प्रीमियम रद्द करें",
    cancel_confirm: "प्रीमियम रद्द करें? आपकी पहुंच नवीनीकरण तिथि तक बनी रहेगी।",
    plan_cancelled: "प्रीमियम आपकी नवीनीकरण तिथि पर समाप्त होगा",
    cancelling_note: "रद्द हो रहा है — सक्रिय तक",
    renews_on: "नवीनीकरण",
    most_popular: "सबसे लोकप्रिय",
    free_vs_premium: "फ्री और प्रीमियम की तुलना",
    upgrade_success: "EVERMIN {plan} में आपका स्वागत है!",
    welcome_title: "🎉 EVERMIN में आपका स्वागत है!",
    welcome_thanks: "EVERMIN चुनने के लिए धन्यवाद। आपकी सदस्यता अब सक्रिय है।",
    welcome_ready: "आपका {plan} प्लान उपयोग के लिए तैयार है।",
    welcome_ai_limit: "AI सीमा: रोज़ {count} सफल उत्तर।",
    welcome_cta: "शुरू करें",
    sandbox_note: "भुगतान Razorpay द्वारा सुरक्षित रूप से प्रोसेस होते हैं। रद्दीकरण और रिफंड के लिए हमारी रिफंड और रद्दीकरण नीति देखें।",
    downgrade_free: "फ्री पर जाएं",
    keep_premium: "प्रीमियम रखें",
    processing: "प्रोसेस हो रहा है…",

    ai_per_day_label: "AI उत्तर/दिन",
    see_plans: "प्लान देखें",
    you_are_on: "आप हैं",
    upgrade_to: "अपग्रेड करें",
    choose_plan: "यह प्लान चुनें",
    switch_plan: "इस प्लान पर जाएं",
    start_free: "फ्री शुरू करें",
    upgrade_cta: "अपग्रेड करें",
    ob_question: "आप EVERMIN से किसमें मदद चाहते हैं?",
    ob_money: "पैसा और बचत",
    ob_problems: "रोज़मर्रा की समस्याएं",
    ob_docs: "दस्तावेज़ और PDF",
    ob_compare: "चीज़ों की तुलना",
    ob_travel: "यात्रा और योजना",
    ob_everything: "सब कुछ",
    ob_skip: "अभी छोड़ें",
    ob_perfect: "बढ़िया। चलिए आपका EVERMIN सेट करें।",
    ob_setup_desc: "अपनी प्रगति सहेजने और अपना व्यक्तिगत EVERMIN अनुभव अनलॉक करने के लिए एक फ्री खाता बनाएं।",
    ob_signup: "फ्री साइन अप करें",
    ob_login: "लॉग इन करें",
    ml_teaser_headline: "आपकी ज़िंदगी। एक स्मार्ट जगह।",
    ml_teaser_sub: "अपनी गणनाएं, लक्ष्य, प्लान, तुलनाएं और ज़रूरी EVERMIN काम एक निजी जगह पर सहेजें।",
    ml_teaser_preview_label: "आपके निजी EVERMIN की एक झलक",
    ml_teaser_make_yours: "इसे अपना बनाने के लिए फ्री खाता बनाएं।",
    ml_teaser_cta: "मेरा EVERMIN बनाएं — फ्री",
    ml_teaser_no_payment: "कोई भुगतान ज़रूरी नहीं।",
    ml_teaser_personalize: "पहले बताएं, आपको किसमें मदद चाहिए",
    ob_build: "बढ़िया। चलिए आपका EVERMIN बनाते हैं।",
    intro_offer: "3-महीने का परिचयात्मक ऑफ़र",
    launch_convert_msg: "EVERMIN मुफ़्त आज़माएं। देखें यह क्या कर सकता है। ज़रूरत होने पर अपग्रेड करें।",
    launch_badge: "सीमित समय के लिए मुफ़्त",
    launch_banner: "EVERMIN लॉन्च अवधि: चुनिंदा प्रीमियम सुविधाएं अभी सभी के लिए मुफ़्त हैं। आज आज़माएं, लॉन्च समाप्त होने पर पहुंच बनाए रखने के लिए अपग्रेड करें।",
    launch_free_support: "EVERMIN लॉन्च अवधि के दौरान यह प्रीमियम सुविधा मुफ़्त आज़माएं।",
    upgrade_to_keep: "पहुंच बनाए रखने के लिए अपग्रेड करें",
    keep_plan: "मेरा प्लान रखें",
    free_tier: "फ्री",
    upgrade_prompt_paid: "EVERMIN से और पाएं",
    limit_title: "आपकी दैनिक AI सीमा पूरी हो गई",
    limit_desc: "आपने आज अपने {count} {plan} AI उत्तर उपयोग कर लिए हैं। आपकी पहुंच कल रीसेट होगी, या अधिक AI पहुंच के लिए अभी अपग्रेड करें।",
    limit_reached_title: "दैनिक AI सीमा पूरी",
    limit_pro_desc: "आपने आज सभी 200 प्रो AI उत्तर उपयोग कर लिए हैं। आपकी सीमा कल रीसेट होगी।",

    take_photo: "फ़ोटो लें",
    upload_image: "फ़ोटो या PDF अपलोड करें",
    ask_about_image_ph: "इस फ़ोटो के बारे में पूछें… (वैकल्पिक)",
    image_type_error: "कृपया JPG, PNG, WEBP इमेज या PDF चुनें।",
    image_size_error: "यह फ़ाइल 10 MB से बड़ी है। कृपया छोटी फ़ाइल चुनें।",

    tab_conversations: "बातचीत",
    upgrade_prompt: "आप फ्री प्लान पर हैं",
    upgrade_prompt_desc: "अधिक दैनिक AI सीमा, अधिक सेव और एडवांस टूल्स के लिए अपग्रेड करें।",
    see_premium: "प्लान देखें",
    saved_limit_reached: "आपकी फ्री सहेजने की सीमा पूरी हो गई। असीमित के लिए अपग्रेड करें।",
    continue_chat: "जारी रखें",

    your_budget: "आपका बजट (वैकल्पिक)",
    your_budget_ph: "जैसे ₹20,000 से कम",
    your_needs: "आपकी ज़रूरतें और प्राथमिकताएं (वैकल्पिक)",
    your_needs_ph: "जैसे लंबी बैटरी, अच्छा कैमरा, रोज़ ऑफ़िस उपयोग के लिए",
    best_for_you: "आपके लिए बेहतर",
    running_cost_label: "चलने / रखरखाव लागत",
    best_for_label: "किसके लिए बेहतर",
    advanced_compare: "निजीकरण (मेरे लिए कौन सा?)",

    trust_title: "भरोसा और स्रोत",
    trust_subtitle: "EVERMIN कैसे काम करता है, और इसे समझदारी से कैसे उपयोग करें।",
    privacy_title: "गोपनीयता नीति",
    terms_title: "उपयोग की शर्तें",
    contact_title: "संपर्क",
    contact_subtitle: "हम आपसे सुनना पसंद करेंगे।",
    footer_about: "हमारे बारे में",
    footer_contact: "संपर्क",
    footer_privacy: "गोपनीयता",
    footer_terms: "शर्तें",
    footer_refund: "रिफंड और रद्दीकरण",
    footer_trust: "भरोसा और स्रोत",
    refund_title: "रिफंड और रद्दीकरण नीति",
    refund_subtitle: "EVERMIN सदस्यता कैसे रद्द की जा सकती है और रिफंड कब लागू होते हैं।",
  },
};
